import {observable, action, computed} from 'mobx'
import {IParty} from '../types/party'

export class PartyStore {
  @observable
  parties: IParty[] = []

  @action
  setParties(parties: IParty[]) {
    this.parties = parties
  }

  @computed
  get globalParties() {
    return this.parties.filter(p => !p.constituency_id)
  }
}
